module.exports = __webpack_public_path__ + "img/132.10.04e03da4.png";